import { render, staticRenderFns } from "./LeiloeiroStats.vue?vue&type=template&id=1911a4c8&"
import script from "./LeiloeiroStats.vue?vue&type=script&lang=js&"
export * from "./LeiloeiroStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports